import React, { useState, useRef, useEffect } from 'react';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import { getClasificationsList } from '../../../services/user.service';
import { uploadAssetsCapt } from '../../../services/asset.service';
import * as CryptoJS from 'crypto-js';
import './AssetInfo.css';

const templatePath      = '/exceltemplates/Parent_Asset_capitalization_Template.xlsx';
const childTemplatePath = '/exceltemplates/Child_Asset_capitalization_Template.xlsx';
const download_img_Url  = '/new-download.gif';

const columns = [
  { field: 'id',              editable: false, hide: true,  headerName: 'Category Id',              width: 100 },
  { field: 'category_name',   editable: false, hide: false, headerName: 'Financials Classification', flex: 1   },
  { field: 'company_details', editable: false, hide: true,  headerName: 'Category Details',          width: 350 },
];

/* ── SVG Download Icon ── */
const DownloadSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
  </svg>
);

/* ── Loading Overlay ── */
const LoadingOverlay = () => (
  <div className="loading-overlay">
    <div className="loading-card">
      <div className="loading-spinner">
        <img src={download_img_Url} alt="Uploading" />
      </div>
      <h5 className="loading-title">Uploading Assets…</h5>
      <p className="loading-subtitle">
        <i className="bi bi-info-circle-fill" />
        Please don&apos;t refresh the page until the process is completed
      </p>
    </div>
  </div>
);

/* ============================================================
   AssetInfo – Bulk Capitalization
   ============================================================ */
function AssetInfo() {

  const errRef = useRef();
  const [validName, setValidName] = useState(false);   // original state kept
  const [errMsg,    setErrMsg]    = useState('');
  const [success,   setSuccess]   = useState(false);
  const [loading,   setLoading]   = useState(false);
  const [loading1,  setLoading1]  = useState(false);
  const [items,     setItems]     = useState([]);

  /* original cell edit handler */
  var onCellEditStopFn = (event, newCell) => {
    var obj = {};
    obj[newCell.field] = event.target.value;
  };

  /* original useEffect */
  useEffect(() => {
    let EncryptData = CryptoJS.AES.encrypt(
      JSON.stringify({ authToken: sessionStorage.getItem('LoggedInToken') }),
      process.env.REACT_APP_ENCRYPT_SECRET_KEY
    ).toString();
    let oData = { token: EncryptData };
    getClasificationsList(oData).then(res => {
      if (res?.data?.data?.length) setItems(res.data.data);
    });
  }, []);

  /* original parent upload handler */
  const onChangeFile = async (event) => {
    event.preventDefault();
    if (
      event.target.files[0]?.name.split('.').pop() === 'undefined' ||
      event.target.files[0]?.name.split('.').pop() !== 'xlsx'
    ) {
      setErrMsg('Please upload valid format. excel file only allowed.');
      return false;
    } else {
      try {
        const data = new FormData();
        data.append('file',                  event.target.files[0]);
        data.append('capitalization_status', 'Y');
        data.append('company_id',            sessionStorage.getItem('LoggedInCompanyId'));
        data.append('division_id',           sessionStorage.getItem('LoggedInDivisionId'));
        data.append('division_code',         sessionStorage.getItem('LoggedInDivisionCode'));
        data.append('created_by',            sessionStorage.getItem('LoggedInUserId'));
        data.append('child_capt',            'no');
        setLoading('..');
        uploadAssetsCapt(data).then(res => {
          if (typeof res.data.errors !== 'undefined' && res.data.errors.errno > 0) {
            setErrMsg(res.data.message); setLoading(false); setSuccess(false);
          } else {
            setSuccess(res.data.message); setLoading(false);
          }
        });
      } catch (error) {
        setLoading(false);
        console.error(error);
        setErrMsg(error.data.message);
      }
    }
  };

  /* original child upload handler */
  const onChangeFile1 = async (event) => {
    event.preventDefault();
    if (
      event.target.files[0]?.name.split('.').pop() === 'undefined' ||
      event.target.files[0]?.name.split('.').pop() !== 'xlsx'
    ) {
      setErrMsg('Please upload valid format. excel file only allowed.');
      return false;
    } else {
      try {
        const data = new FormData();
        data.append('file',                  event.target.files[0]);
        data.append('capitalization_status', 'Y');
        data.append('company_id',            sessionStorage.getItem('LoggedInCompanyId'));
        data.append('division_id',           sessionStorage.getItem('LoggedInDivisionId'));
        data.append('created_by',            sessionStorage.getItem('LoggedInUserId'));
        data.append('child_capt',            'yes');
        setLoading1('..');
        uploadAssetsCapt(data).then(res1 => {
          if (typeof res1.data.errors !== 'undefined' && res1.data.errors.errno > 0) {
            setErrMsg(res1.data.message); setLoading1(false); setSuccess(false);
          } else {
            setSuccess(res1.data.message); setLoading1(false);
          }
        });
      } catch (error) {
        setLoading1(false);
        console.error(error);
        setErrMsg(error.data.message);
      }
    }
  };

  /* ── instructions data ── */
  const instructions = [
    {
      title: 'Date Format:',
      body: <>Always use <code>YYYY-MM-DD</code> format for dates</>
    },
    {
      title: 'Empty Cells:',
      body: <>Use <code>NA</code> for text and <code>0</code> for numbers</>
    },
    {
      title: 'Company Name:',
      body: <>Use <code>{sessionStorage.getItem('LoggedInCompanyName')}</code></>
    },
    {
      title: 'Branch Name:',
      body: <>Use <code>{sessionStorage.getItem('LoggedInDivisionName')}</code></>
    },
    {
      title: 'TAG Branch:',
      body: <>Use <code>{sessionStorage.getItem('LoggedInDivisionShortName')}</code></>
    },
    {
      title: 'Prerequisites:',
      body: <>Parent assets must be added before child assets</>
    },
  ];

  /* ====================================================
     RENDER
     ==================================================== */
  return (
    <div className="asset-info-container">

      {/* ── Loading Overlays ── */}
      {loading  && <LoadingOverlay />}
      {loading1 && <LoadingOverlay />}

      {/* ════════════════════════════
          PAGE HEADER
          ════════════════════════════ */}
      <div className="page-header">
        <div className="header-content">
          <div className="header-left">
            <div className="header-icon">
              <i className="bi bi-cloud-arrow-up-fill" style={{ fontSize: '1.6rem' }} />
            </div>
            <div>
              <h1 className="page-title">Bulk Capitalization</h1>
              <p className="page-subtitle">Upload multiple assets using Excel templates</p>
            </div>
          </div>
          <a href="/assets-capitalized" className="btn-outline-primary">
            <i className="bi bi-list-ul" /> Asset List
          </a>
        </div>

        {/* Alert banners */}
        {success ? (
          <div className="alert-success-modern" role="alert">
            <i className="bi bi-check-circle-fill" /> {success}
          </div>
        ) : errMsg ? (
          <div className="alert-danger-modern" role="alert" ref={errRef}>
            <i className="bi bi-exclamation-triangle-fill" /> {errMsg}
          </div>
        ) : null}
      </div>

      {/* ════════════════════════════
          UPLOAD CARDS
          ════════════════════════════ */}
      <div className="upload-cards-grid">

        {/* ── Parent Card ── */}
        <div className="upload-card parent-card" id="parent-upload-card">
          <div className="card-header">
            <div className="card-icon parent-icon">
              <i className="bi bi-file-earmark-spreadsheet" style={{ fontSize: '1.4rem' }} />
            </div>
            <div className="card-header-text">
              <h4>Parent Asset Addition</h4>
              <p>Upload parent asset details via Excel</p>
            </div>
          </div>
          <div className="card-body">
            <div className="upload-area" id="parent-upload-area">
              <Button
                variant="contained"
                component="label"
                className="upload-button"
                id="parent-upload-btn"
              >
                <i className="bi bi-cloud-upload" style={{ marginRight: 8 }} />
                Upload Parent Assets
                <input hidden type="file" onChange={onChangeFile} />
              </Button>
            </div>
            {loading && (
              <div style={{ textAlign: 'center', fontSize: '0.82rem', color: '#0e8aca', fontWeight: 500 }}>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Processing upload…
              </div>
            )}
            <div className="template-download">
              <a href={templatePath} className="download-link" id="parent-template-link">
                <DownloadSVG /> Download Parent Template
              </a>
            </div>
          </div>
        </div>

        {/* ── Child Card ── */}
        <div className="upload-card child-card" id="child-upload-card">
          <div className="card-header">
            <div className="card-icon child-icon">
              <i className="bi bi-file-earmark-arrow-up" style={{ fontSize: '1.4rem' }} />
            </div>
            <div className="card-header-text">
              <h4>Child Asset Addition</h4>
              <p>Upload child asset details via Excel</p>
            </div>
          </div>
          <div className="card-body">
            <div className="upload-area" id="child-upload-area">
              <Button
                variant="contained"
                component="label"
                className="upload-button"
                id="child-upload-btn"
              >
                <i className="bi bi-cloud-upload" style={{ marginRight: 8 }} />
                Upload Child Assets
                <input hidden type="file" onChange={onChangeFile1} />
              </Button>
            </div>
            {loading1 && (
              <div style={{ textAlign: 'center', fontSize: '0.82rem', color: '#0e8aca', fontWeight: 500 }}>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Processing upload…
              </div>
            )}
            <div className="template-download">
              <a href={childTemplatePath} className="download-link" id="child-template-link">
                <DownloadSVG /> Download Child Template
              </a>
            </div>
          </div>
        </div>

      </div>{/* /upload-cards-grid */}

      {/* ════════════════════════════
          INSTRUCTIONS
          ════════════════════════════ */}
      <div className="instructions-section" id="instructions-section">
        <div className="instructions-header">
          <span className="instructions-badge-icon">i</span>
          <h4>Instructions for Bulk Upload</h4>
        </div>
        <div className="instructions-grid">
          {instructions.map((item, idx) => (
            <div className="instruction-item" key={idx} id={`instruction-item-${idx + 1}`}>
              <div className="instruction-number">{idx + 1}</div>
              <div className="instruction-content">
                <strong>{item.title}</strong>
                {item.body}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ════════════════════════════
          DROPDOWN REFERENCE VALUES
          ════════════════════════════ */}
      <div className="reference-section" id="reference-section">
        <h4 className="reference-title">
          <i className="bi bi-grid-3x3-gap-fill" /> Dropdown Reference Values
        </h4>
        <p className="reference-subtitle">
          Use these values for dropdown fields in the Excel template
        </p>

        <div className="data-grid-container">
          <div className="grid-card" id="classification-grid-card">
            <div className="grid-header">
              <h5>Financials Classification</h5>
            </div>
            <DataGrid
              className="custom-datagrid"
              rows={items}
              getRowId={(row) => row.id}
              columns={columns}
              pageSize={5}
              autoHeight
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </div>
        </div>
      </div>

    </div>/* /asset-info-container */
  );
}

export default AssetInfo;
